import { RouteConfig } from 'vue-router';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';
import { ScopeEnum } from '@/types/enum/ScopeEnum';

const exportRoute = [
	{
		path: '/exports/administration',
		name: 'exports',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.ADMINISTRATION },
		meta: {
			label: 'router.label.exportsAccessMaster',
			subLabel: 'router.subLabel.administration',
			can: PagePermissionEnum.EXPORTS_ADMINISTRATION,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/validation',
		name: 'exportsValidation',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.VALIDATION },
		meta: {
			label: 'router.label.exportsAccessMaster',
			subLabel: 'router.subLabel.validation',
			can: PagePermissionEnum.EXPORTS_VALIDATION,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/liquidation',
		name: 'exportsLiquidation',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.LIQUIDATION },
		meta: {
			label: 'router.label.exportsAccessMaster',
			subLabel: 'router.subLabel.liquidation',
			can: PagePermissionEnum.EXPORTS_LIQUIDATION,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/supervision',
		name: 'exportsSupervision',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.SUPERVISION },
		meta: {
			label: 'router.label.exportsAccessMaster',
			subLabel: 'router.subLabel.supervision',
			can: PagePermissionEnum.EXPORTS_SUPERVISION,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/evaluation_tc',
		name: 'exportsEvaluationTC',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.EVALUATION_TC },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.evaluation_tc',
			can: PagePermissionEnum.EXPORTS_EVAL_TC,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/evaluation_dm',
		name: 'exportsEvaluationDM',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
		),
		props: { scope: ScopeEnum.EVALUATION_DM },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.evaluation_dm',
			can: PagePermissionEnum.EXPORTS_EVAL_DM,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/control_file_tc',
		name: 'exportsControlFileTC',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
			),
		props: { scope: ScopeEnum.CONTROL_FILE_TC },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.control_file_tc',
			can: PagePermissionEnum.EXPORTS_CONTROL_FILE_TC,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/control_file_dm',
		name: 'exportsControlFileDM',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
			),
		props: { scope: ScopeEnum.CONTROL_FILE_DM },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.control_file_dm',
			can: PagePermissionEnum.EXPORTS_CONTROL_FILE_DM,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/experience_patient_admin',
		name: 'exportsExpPatientAdmin',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
			),
		props: { scope: ScopeEnum.SURVEY_CAMPAIGN_ADMINISTRATION },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.exp_patient_administration',
			can: PagePermissionEnum.EXPERIENCE_PATIENT_ADMINISTRATION,
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/exports/dgos',
		name: 'exportsDgos',
		component: () => import(
			'../../components/export/GlobalExportList.vue'
			),
		props: { scope: ScopeEnum.VALIDATION_DGOS },
		meta: {
			label: 'router.label.exports',
			subLabel: 'router.subLabel.dgos',
			can: PagePermissionEnum.EXPORTS_DGOS,
			hiddenOnProjectRoute: true
		}
	}
] as RouteConfig[];

export default exportRoute;
